document.querySelectorAll('.copy-btn').forEach(button => {
  button.addEventListener('click', function () {
    const container = this.closest('.code-header').nextElementSibling;
    const codeBlock = container ? container.querySelector('code') : null;

    if (!codeBlock) return;

    const language = document.documentElement.lang.toLowerCase();
    const isEnglish = language.startsWith('en');

    const defaultText = isEnglish ? 'Copy code' : 'Копировать код';
    const copiedText = isEnglish ? 'Copied!' : 'Скопировано!';

    navigator.clipboard.writeText(codeBlock.innerText).then(() => {
      this.textContent = copiedText;

      setTimeout(() => {
        this.textContent = defaultText;
      }, 2000);
    });
  });
});